import { render, staticRenderFns } from "./LicenceRegistration.vue?vue&type=template&id=b2d63cec&scoped=true"
import script from "./LicenceRegistration.vue?vue&type=script&lang=js"
export * from "./LicenceRegistration.vue?vue&type=script&lang=js"
import style0 from "./LicenceRegistration.vue?vue&type=style&index=0&id=b2d63cec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d63cec",
  null
  
)

export default component.exports